module.exports = __webpack_public_path__ + "img/gbmb_login_left.12a92b24.jpg";